module.exports = __webpack_public_path__ + "static/media/connatix-exchange-demang-icon.13404a0d.svg";